import { PageHero } from "../components/site/PageHero";
import { ClientWall } from "../components/site/ClientWall";
import { ReviewList } from "../components/site/Reviews";
import { ReviewForm } from "../components/site/ReviewForm";
import { Eyebrow, MaskLines } from "../components/site/Reveal";

export default function Clients() {
  return (
    <>
      <PageHero testid="clients-hero" eyebrow="Clients & reviews" lines={["In good", <span className="font-serif-i text-[var(--brass-deep)]">company.</span>]} intro="The intermediaries we work with, and what they say about working with us." />
      <section className="bg-paper py-20 sm:py-28">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
          <Eyebrow>Our clients</Eyebrow>
          <div className="mt-10"><ClientWall /></div>
        </div>
      </section>
      <section className="bg-paper-2 py-20 sm:py-28">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
          <Eyebrow>Client reviews</Eyebrow>
          <div className="mt-10">
            <ReviewList onEmpty={<p data-testid="reviews-empty" className="font-serif-i text-2xl text-ink/65">No reviews published yet — be the first to share your experience below.</p>} />
          </div>
        </div>
      </section>
      <section id="write-review" data-testid="write-review-section" className="bg-paper text-ink py-20 sm:py-28 border-t border-ink/10">
        <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Eyebrow>Worked with us?</Eyebrow>
            <h2 className="mt-6 font-display font-extrabold tracking-[-0.035em] leading-[0.95] text-4xl sm:text-6xl">
              <MaskLines inView lines={["Leave a", <span className="font-serif-i text-[var(--brass-deep)]">review.</span>]} />
            </h2>
            <p className="mt-6 text-ink/70 max-w-sm">Reviews are published after a quick verification by our team.</p>
          </div>
          <div className="lg:col-span-7"><ReviewForm /></div>
        </div>
      </section>
    </>
  );
}
